﻿import { Field } from 'components/uikit/Field';
import styles from './TemplateMergingPage.module.scss';
import { Input } from 'components/uikit/inputs/Input';
import { Button } from 'components/uikit/buttons/Button';
import { useEventCallback } from '@mui/material';
import { useAdvancedForm } from 'helpers/form/useAdvancedForm';
import { QueryFactory } from 'services/api';
import { useRef, useState } from 'react';
import { Loading } from 'components/uikit/suspense/Loading';
import { FileResponse } from 'services/api/api-client';
import {
  TextButton,
  TextButtonColor,
} from 'components/uikit/buttons/TextButton';
import { FormError } from 'components/uikit/FormError';
import { errorToString } from 'helpers/error-helpers';

type TemplateMergingFormData = {
  original: FileList;
  modified: FileList;
  project: FileList;
};

export const TemplateMergingPage = () => {
  const [resultFile, setResultFile] = useState<FileResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const form = useAdvancedForm<TemplateMergingFormData>(async (data) => {
    setIsLoading(true);
    setResultFile(null);
    try {
      console.log('data', data);
      const original = originalFileRef.current!.files![0];
      const modified = modifiedFileRef.current!.files![0];
      const project = projectFileRef.current!.files![0];
      const result = await QueryFactory.TemplateQuery.Client.updateProjectFile(
        { data: original, fileName: original.name },
        { data: modified, fileName: modified.name },
        { data: project, fileName: project.name },
      );

      setResultFile(result);
      setIsLoading(false);
    } catch (e) {
      let errorDetail = '';
      try {
        const errorText = await (e as Blob).text();
        const errorJson = JSON.parse(errorText);
        errorDetail = errorToString(errorJson);
      } catch {
        throw e;
      }
      throw new Error(errorDetail);
    } finally {
      setIsLoading(false);
    }
  });
  const originalFileRef = useRef<HTMLInputElement>(null);
  const modifiedFileRef = useRef<HTMLInputElement>(null);
  const projectFileRef = useRef<HTMLInputElement>(null);
  return (
    <div className={styles.mainContainer} data-test-id="templates-page">
      <Loading loading={isLoading}>
        <div className={styles.body}>
          <form onSubmit={form.handleSubmitDefault}>
            <Field
              title={
                'Original template (you might select multiple files and the 2nd and 3rd will be copied to inputs below)'
              }
            >
              <Input
                type="file"
                {...form.register('original')}
                multiple={true}
                onChange={(event) => {
                  const originalFiles = event.target.files || [];
                  if (originalFiles.length >= 2) {
                    modifiedFileRef.current!.files = (() => {
                      const dt = new DataTransfer();
                      dt.items.add(originalFiles[1]);
                      return dt.files;
                    })();
                    modifiedFileRef.current!.dispatchEvent(
                      new Event('change', { bubbles: true }),
                    );
                  }
                  if (originalFiles.length >= 3) {
                    projectFileRef.current!.files = (() => {
                      const dt = new DataTransfer();
                      dt.items.add(originalFiles[2]);
                      return dt.files;
                    })();
                    projectFileRef.current!.dispatchEvent(
                      new Event('change', { bubbles: true }),
                    );
                  }

                  if (originalFiles.length > 1) {
                    originalFileRef.current!.files = (() => {
                      const dt = new DataTransfer();
                      dt.items.add(originalFiles[0]);
                      return dt.files;
                    })();
                    originalFileRef.current!.dispatchEvent(
                      new Event('change', { bubbles: true }),
                    );
                  }
                }}
                ref={originalFileRef}
              />
            </Field>
            <Field title={'Modified template'}>
              <Input
                type="file"
                {...form.register('modified')}
                ref={modifiedFileRef}
              />
            </Field>
            <Field title={'Project file'}>
              <Input
                type="file"
                {...form.register('project')}
                ref={projectFileRef}
              />
            </Field>
            <Button type="submit" title="Merge" />
            {!!form.formErrorCombined && (
              <FormError>{form.formErrorCombined}</FormError>
            )}
          </form>

          {resultFile && (
            <div>
              <TextButton
                testId="to-templates-merging"
                className={styles.button}
                title={'Download result'}
                color={TextButtonColor.Primary}
                onClick={() => {
                  if (resultFile) {
                    saveBlob(
                      resultFile.data,
                      resultFile.fileName || 'result.docx',
                    );
                  }
                }}
              />
            </div>
          )}
        </div>
      </Loading>
    </div>
  );
};
function saveBlob(blob: Blob, fileName: string) {
  var a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';

  var url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}
